import { useSelector } from "react-redux";
import { selectState } from "../incident.slice";
import { FormatNumber } from "utils/numberUtils";

const TableFooter = () => {
  const { incidents, totalAmount } = useSelector(selectState);

  return (
    <div className="g-grid g-footer">
      <div className="row">
        <div></div>
        <div></div>
        <div className="col light">
          <div className="bg-item-border-light center">{incidents.length}</div>
        </div>
        <div className="col light">
          <div className="bg-item-border-light center">
            {FormatNumber(totalAmount)} rsd
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default TableFooter;
